import { render, staticRenderFns } from "./jfjl.vue?vue&type=template&id=2ac9ac36&"
import script from "./jfjl.vue?vue&type=script&lang=js&"
export * from "./jfjl.vue?vue&type=script&lang=js&"
import style0 from "./jfjl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports